<template>

  <div class="cart-item">
    <div class="cart-item__wrapper">
      <div class="cart-item__l">
        <div class="cart-item__image">
          <img :src="getItemImage(item.product)" alt="item.product.name"/>
        </div>
      </div>

      <div class="cart-item__r">
        <div class="cart-item__info">
          <div class="cart-item__info-l">
            <h4>{{ getProductTitle(item.product) }}</h4>
            <p>{{ getProductModelDescription(item.product.model) }}</p>
            <p v-if="getFrameNumber(item)" class="cart-item__number"><strong>{{ trans.text.cart.frameNumberLabel }}
              {{ getFrameNumber(item) }}/999</strong></p>
            <p v-if="!item.is_pre_order" class="boldText visible-xs">{{ trans.text.cart.exclusivePrice }}</p>
            <div v-if="item.is_pre_order || !(!!item.frame_number)" class="cart-item__controls visible-xs">
              <div class="cart-item__controls-l">
                <div class="countSelect-wrap">
                  <select id="countSelect" v-model="item.quantity" class="countSelect"
                          name="count" @change="changeQuantityManual(item)">
                    <option v-for="item in quantityList" :value="item.id">{{ item.text }}</option>
                  </select>
                </div>

              </div>

              <div class="cart-item__controls-r">
                <div class="cart-item__total">{{ getSum(item) }}</div>
                <button class="cart-item__remove" @click.prevent="deleteFromBag(item)">
                  {{ trans.text.cart.remove }}
                </button>
                <p v-if="item.is_pre_order">{{ trans.text.cart.reservPrice }}</p>
                <p v-if="!item.is_pre_order" class="boldText">{{ trans.text.cart.exclusivePrice }}</p>
              </div>
            </div>

            <div class="cart-item__more">
              <ul>
                <li v-for="part in getFirstParts(item.product.rel_parts)">
                  <strong>{{ getCategoryTitle(part) }}</strong> - {{ getPartTitle(part) }}
                </li>
                <li v-for="part in getOthersParts(item.product.rel_parts)" v-show="false"
                    :ref="`more-${item.id}`">
                  <strong>{{ getCategoryTitle(part) }}</strong> - {{ getPartTitle(part) }}
                </li>
              </ul>
            </div>

            <a :ref="`more-toggle-${item.id}`" class="btn-link"
               @click.prevent="showMore(item)">{{ trans.text.cart.more }}</a>
          </div>

          <div class="cart-item__info-r">
            <div class="cart-item__controls hidden-xs">
              <div class="cart-item__controls-l">
                <div class="cart-item__qty">
                  <div class="qty">
                    <button v-if="item.is_pre_order || !(!!item.frame_number)" class="qty__plus"
                            @click="increment(item)">+
                    </button>

                    <input v-if="!maxQuantity" v-model="item.quantity" class="qty__value"
                           disabled="disabled" type="text">

                    <input v-if="maxQuantity"
                           :value="'max'"
                           class="qty__value"
                           disabled="disabled"
                           type="text">

                    <button v-if="item.is_pre_order || !(!!item.frame_number)" class="qty__minus"
                            @click="decrement(item)">
                      -
                    </button>
                  </div>
                </div>
              </div>

              <div class="cart-item__controls-r">
                <div class="cart-item__total">{{ getSum(item) }}</div>
                <button class="cart-item__remove" @click.prevent="deleteFromBag(item)">
                  {{ trans.text.cart.remove }}
                </button>
                <p v-if="item.is_pre_order" class="boldText">{{ trans.text.cart.reservPrice }}</p>
                <p v-if="!item.is_pre_order" class="boldText">{{ trans.text.cart.exclusivePrice }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CartItemComponent",
  props: ['item', 'lang', 'trans'],
  data() {
    return {
      quantityError: null,
      maxQuantity: false
    }
  },
  computed: {
    ...mapGetters(['storage', 'cartItems']),
    quantityList() {
      let array = [];
      for (let key of [...Array(25).keys()]) {
        if (key > 0) {
          array.push({
            id: key,
            text: key,
          });
        }
      }

      return array;
    },
    select2Options() {
      return {
        minimumResultsForSearch: -1
      }
    }
  },
  methods: {
    ...mapActions(['ChangeQuantity', 'DeleteFromBag']),
    getItemImage(product) {
      if (product.product_media_pages.length > 0) {
        if (!!product.product_media_pages[0].page_images) {
          return this.getStorageLink(product.product_media_pages[0].page_images);
        }
      } else if (!!product.model && !!product.model.img) {
        return this.getStorageLink(product.model.img);
      }
      return '/images/cart/cart2.png';
    },
    getStorageLink(path) {
      return this.storage + path;
    },
    getProductTitle(product) {
      return product.name_website;
    },
    getFrameNumber(item) {
      return item.frame_number || null;
    },
    getProductModelDescription(model) {
      if (model[`${this.lang}_desc`]) {
        return model[`${this.lang}_desc`].replace(/(<([^>]+)>)/ig, "");
      }
      return model.desc.replace(/(<([^>]+)>)/ig, "");
    },
    showMore(item) {
      $(this.$refs[`more-${item.id}`]).slideToggle(250);
      let toggleBtn = $(this.$refs[`more-toggle-${item.id}`]);
      toggleBtn.text(
        toggleBtn.text().trim() === this.trans.text.cart.more
          ? this.trans.text.cart.less : this.trans.text.cart.more
      );
    },
    getSinglePrice(product) {
      let price = parseInt(product.price) + this.counting(product.rel_parts);
      return this.$crConverter(price, 'EUR');
    },
    counting(parts) {
      let price = 0;
      for (let part of parts) {
        if (part.category.as_option === 1) {
          price += parseInt(part.price_out);
        }
      }
      return price;
    },
    decrement(item) {
      if (item.quantity !== 1) {
        this.quantityError = null
        item.quantity--;
        this.ChangeQuantity({
          id: item.id,
          path: this.$path,
          quantity: item.quantity,
          product_id: item.product.id,
          total: this.total
        }).catch(resp => {
          this.quantityError = resp.response.data.message
          item.quantity--;
        });
      }
    },
    getCountInCart() {
      let count = 0;
      for (let item of this.cartItems) {
        count += item.quantity;
      }

      return count;
    },
    increment(item) {
      let countInCart = this.getCountInCart();
      if (countInCart + 1 > 24) {
        this.maxQuantity = true
        setTimeout(() => {
          this.maxQuantity = false;
        }, 5000)
        return;
      }
      if (this.quantityError == null) {
        item.quantity++
        this.ChangeQuantity({
          id: item.id,
          path: this.$path,
          quantity: item.quantity,
          product_id: item.product.id,
          total: this.total
        }).catch(resp => {
          this.quantityError = resp.response.data.message
          item.quantity--;
        });
      }
    },
    changeQuantityManual(item) {
      let countInCart = this.getCountInCart;
      if (this.quantityError == null) {
        this.ChangeQuantity({
          id: item.id,
          path: this.$path,
          quantity: countInCart + item.quantity > 24 ? 24 : item.quantity,
          product_id: item.product.id,
          total: this.total
        }).catch(resp => {
          this.quantityError = resp.response.data.message
        });
      }
    },
    getSum(item) {
      let price;
      if (item.is_pre_order) {
        price = parseInt(item.quantity) * item.pre_order_price;
      } else {
        price = parseInt(item.quantity) * ((parseInt(item.product.price) + this.counting(item.product.rel_parts)));
      }
      return this.$crConverter(price, 'EUR');
    },
    getPartTitle(part) {
      if (!!part) {
        if (part[`description_short_${this.lang}`]) {
          return part[`description_short_${this.lang}`];
        }
        return part[`description_short_en`];
      }
      return '';
    },
    getFirstParts(parts) {
      return parts.slice(0, 12);
    },
    getOthersParts(parts) {
      return parts.slice(12);
    },
    getCategoryTitle(part) {
      if (!!part && !!part.category) {
        if (part.category[`${this.lang}_title`]) {
          return part.category[`${this.lang}_title`];
        }
        return part.category[`en_title`];
      }
      return '';
    },
    deleteFromBag(item) {
      this.DeleteFromBag({
        path: this.$path,
        id: item.id,
        quantity: item.quantity
      }).then(response => {
        let gtag = response.data.gtag;
        if (gtag) {
          this.$gtag.event('remove_from_cart', {
            currency: 'EUR',
            items: [gtag]
          })
        }
      }).catch(error => {
        console.log(error)
      });
    },
  }

}
</script>

<style scoped>
.cart-item__total {
  /*width: 13% !important; - на странице /cart на телефоне цена слетает*/

}

.quantity_error {
  font-size: 13px;
  color: red;
}
</style>
